export default function validateSSNSettings(ssn: string, isSSNMandatory: boolean, formatDateOfBirth: string): boolean {
    if (!ssn) {
        return true;
    }
    //Full ssn required
    if (isSSNMandatory) {
        // SSN could be with or without "-"
        if (ssn.length < 12 || ssn.length > 13) {
            return false;
        }
    }

    if (!formatDateOfBirth) {
        // Not mandatory SSN and no format for date of birth. We are in trouble! :P
        return true;
    }

    /*Conform to the length of formatDateBirthSetting*/
    if (!isSSNMandatory && formatDateOfBirth.length != ssn.length) {
        //Allow both yyyymmddxxxx and yyyymmdd-xxxx even with a formatDateOfBirth setting
        if ((ssn.length == 12 && ssn.indexOf('-') === -1) || (ssn.length == 13 && ssn.charAt(8) == '-')) {
            return true;
        }
        return false;
    }
    
    return true;
} 